import { Chip } from '@material-ui/core';
import * as moment from 'moment';
import * as React from 'react';
import { hasRole } from 'shared/models/user';

import { useProfileDataSource } from '../hooks/use-profile-data-source';
import { useSession } from '../hooks/use-session';

interface ProfileAgeProps {
    viewedAt: number;
}

const [amberA100, black, deepOrangeA100, greenA100, greenA400, white, yellow500] = [
    '#ffab00',
    '#000000',
    '#dd2c00',
    '#00c853',
    '#00e676',
    '#ffffff',
    '#ffeb3b'
];

export const ProfileAge = ({ viewedAt }: ProfileAgeProps) => {
    const { showProfileDataSource } = useProfileDataSource();
    const { userPermissions } = useSession();

    const handleClick = () => {
        showProfileDataSource();
    };

    const canShowProfileDataSource = hasRole(userPermissions, 'blacklist_editor');

    const age = moment().diff(viewedAt, 'days');
    // tslint:disable:no-magic-numbers
    const ageBgColor =
        age <= 14 ? greenA100 : age <= 60 ? greenA400 : age <= 90 ? yellow500 : age <= 120 ? amberA100 : deepOrangeA100;
    const ageTextColor = ageBgColor === deepOrangeA100 ? white : black;
    // tslint:enable:no-magic-numbers
    return (
        <Chip
            style={{ backgroundColor: ageBgColor, color: ageTextColor }}
            label={moment(viewedAt).fromNow()}
            onClick={canShowProfileDataSource ? handleClick : undefined}
        />
    );
};
